import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IntegrationCardComponent } from '@app/components/integration-card/integration-card.component';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { Components } from '@import/components';
import { ImportRouterModule } from '@import/import.routes';
import { Services } from '@import/services';
import { Views } from '@import/views';
import { CompanyFormsModule } from '../forms/company/company-forms.module';
import { SettingsFormsModule } from '../forms/settings/settings-forms.module';
import { ImportLauncherComponent } from './components/import-launcher/import-launcher.component';
import IntegrationImportSteps from './views/integrations/steps';

@NgModule({
    imports: [
        ImportRouterModule,
        CommonModule,
        AppCommonModule,
        FormsModule,
        PlatformModule,
        ReactiveFormsModule,
        CompanyFormsModule,
        SettingsFormsModule,
        ImportLauncherComponent,
        IntegrationCardComponent,
        ...IntegrationImportSteps,
    ],
    declarations: [...Views, ...Components],
    providers: [Services],
})
export class ImportModule {}
